Array.prototype.Contains = function(key) {
    return this.indexOf(key) !== -1;
};

String.prototype.toLowerCaseFirst = function() {
    return this.slice(0, 1).toLowerCase() + this.slice(1);
};

String.prototype.Replace = function(s, r) {
    return this.replace(s, r);
};

String.prototype.trim = String.prototype.trim || function() {
    return this.replace(/(?:(?:^|\n)\s+|\s+(?:$|\n))/g, '');
};

window.string = {

    Format: function(str) {
        var args = [].slice.call(arguments);
            args.shift();

        for(var i=0, len = args.length; i < len; i++) {
            str = str.replace(new RegExp('\\{'+i+'}', 'g'), args[i]);
        }

        return str;
    },

    IsNullOrEmpty: function(str) {
        return str === null || str === '';
    },

    Join: function(delimiter, arr) {
        return arr.join(delimiter);
    }
};

window.Html = {
    GeneratePriceRatingsClass: function(index, priceBandId) {
        if (index <= priceBandId) {
            return "on";
        }
        
        return '';
    },

    GenerateRatingsStarClasses: function (starIndex, rating) {
        if (starIndex <= rating) {
            return "on";
        }

        var ratingRoundedToNearestHalf = Math.round(rating * 2) / 2;
        var ratingRoundedToCeiling = Math.ceil(ratingRoundedToNearestHalf);
        var hasHalfStar = ratingRoundedToCeiling - ratingRoundedToNearestHalf;

        if (starIndex === ratingRoundedToCeiling) {
            return hasHalfStar > 0 ? "half" : "on";
        }

        return '';
    },

    GenerateRatingsStarCount: function (rating) {
        var ratingRoundedToNearestHalf = Math.round(rating * 2) / 2;
        return (ratingRoundedToNearestHalf+"").replace(".","-").replace(",","-");
    },
    
    GetReviewsCountText: function (total, singularFormat, pluralFormat)
    {
        var format = (total > 1) ? pluralFormat : singularFormat;
        return string.Format(format, total);
    }
};
